<template>
  <vx-card>
    
    <form-wizard ref="wizard" color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Submit" @on-complete="submit" >
                <tab-content title="إضافة سؤال" class="mb-5" icon="feather icon-home">
                    <!-- tab 1 content -->
                    <div class="vx-row">
                            <div class="vx-col w-full sm:w-2/4 md:w-2/4 lg:w-2/4 mb-2">
                                    <vs-textarea label="نص السؤال" v-model="question.body" />
                            </div>
                    </div>
                </tab-content>

                <!-- tab 2 content -->
                <tab-content title="إضافة خيارات" class="mb-5" icon="feather icon-briefcase">
                    <vs-row vs-w="12">
                        <vs-col vs-type="flex"  vs-lg="8" vs-sm="4" vs-xs="12" >
                            <vs-input class="w-full"   label="نص الخيار" v-model="choice.body" />
                        </vs-col>
                        <vs-col vs-type="flex" vs-align="center" vs-justify="center"   vs-lg="2" vs-sm="4" vs-xs="12">
                                <vs-checkbox class="mr-2" v-model="choice.result" :disabled="oneChoiceIsTrue">{{ choice.result }}</vs-checkbox>
                        </vs-col>
                        <vs-col vs-type="flex" vs-align="center" vs-justify="center"   vs-lg="2" vs-sm="4" vs-xs="12">
                                <vs-button color="success" type="border" @click="addChoiceToQuestion">إضافة خيار</vs-button>
                        </vs-col>
                    </vs-row>
                    
                    <vs-row vs-w="12" v-for="(item, index) in question.choices" :key="index">
                        <vs-col vs-type="flex"  vs-lg="8" vs-sm="4" vs-xs="12" >
                            <vs-input class="w-full"   label="نص الخيار" v-model="item.body" />
                        </vs-col>
                        <vs-col vs-type="flex" vs-align="center" vs-justify="center"   vs-lg="2" vs-sm="4" vs-xs="12">
                                <vs-checkbox class="mr-2" v-model="item.result" :disabled="oneChoiceIsTrue && !item.result">{{ item.result }}</vs-checkbox>
                        </vs-col>
                        <vs-col vs-type="flex" vs-align="center" vs-justify="center"   vs-lg="2" vs-sm="4" vs-xs="12">
                            <vs-button color="danger" type="border" @click="deleteChoiceFromQuestion(index)">حذف</vs-button>
                        </vs-col>
                    </vs-row>
                </tab-content>

                <!-- tab 3 content -->
                <tab-content title="التحقق" class="mb-5" icon="feather icon-image">
                    <div class="vx-row">
                        <vs-textarea label="نص السؤال" v-model="question.body" :disabled="true"/>
                    </div>
                    <vs-row vs-w="12" v-for="(item, index) in question.choices" :key="index">
                        <vs-col vs-type="flex"  vs-lg="8" vs-sm="4" vs-xs="12" >
                            <vs-input class="w-full"   label="نص الخيار" v-model="item.body" :disabled="true" />
                        </vs-col>
                        <vs-col vs-type="flex" vs-align="center" vs-justify="center"   vs-lg="2" vs-sm="4" vs-xs="12">
                                <vs-checkbox class="mr-2" v-model="item.result" :disabled="true">{{ item.result }}</vs-checkbox>
                        </vs-col>
                        <vs-col vs-type="flex" vs-align="center" vs-justify="center"   vs-lg="2" vs-sm="4" vs-xs="12">
                        </vs-col>
                    </vs-row>
                </tab-content>
            </form-wizard>

  </vx-card>
</template>


<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import axios from 'axios';

export default {
    components: {
    FormWizard,
    TabContent
  },
    data() {
        return {
            question:{
                body: '',
                choices: []
            },
            choice: {
                id: -1,
                body: '',
                result: false
            }
        }
    },
    async mounted(){
        await this.getQuestion();
    },
    methods:{
        async getQuestion(){
            this.$vs.loading();
            await axios.get('/questions/' + this.$route.params.id).then(res => {
                this.question = res.data.data;
            })
            this.$vs.loading.close();
        },
        addChoiceToQuestion(){
            this.question.choices.push({body: this.choice.body, result: this.choice.result, id: -1});
            this.choice.result = false;
            this.choice.body = "";
        },
        deleteChoiceFromQuestion(index){
            this.question.choices.splice(index, 1);
        },
        async submit(){
            this.$vs.loading();
            await axios.put('questions/' + this.$route.params.id, this.question).then(res => {
                this.question.body = "";
                this.question.choices = [];
                this.choice.body = "";
                this.choice.result = false;
                this.$refs.wizard.reset();
                console.log(res);
                this.$router.push('/paragraph/'+ this.question.paragraph_id + '/showQuestions');
            });
            this.$vs.loading.close();
        }
    },
    computed: {
        oneChoiceIsTrue(){
            var res = false;
            this.question.choices.forEach(element => {
                if(element.result) res = true;
            });
            return res;
        }
    }
}
</script>

<style scoped>
.inputChoice{
    width:90rem
}
.checkChoice{
    width: 5rem;
}
</style>